import React from "react";
import "./styles.css";

const Loading = () => {
  return (
    <div className="loaderWrapper">
      <div className="loader">
        <div className="loader__bar" />
        <div className="loader__bar" />
        <div className="loader__bar" />
        <div className="loader__bar" />
        <div className="loader__bar" />
        <div className="loader__ball" />
      </div>
    </div>
  );
};

export default Loading;
